import Tooltip from './Tooltip';

export * from './useTooltip';
export * from './types';

export default Tooltip;
